// extracted by mini-css-extract-plugin
export default {"disabled-icon":"DisabledIcon_disabled-icon__rYKAv","disabled-icon--xs":"DisabledIcon_disabled-icon--xs__9BR8f"};